import { Component, h, Prop } from '@stencil/core';

@Component({
  tag: 'input-number',
  shadow: false,
})
export class InputNumber {
  @Prop() name: string;
  @Prop() label: string;
  @Prop() value: number;
  @Prop() required: boolean;
  @Prop() placeholder: string;
  @Prop() tooltip: string;
  @Prop() disabled: boolean;
/*   @Prop() min: number;
  @Prop() max: number;
  @Prop() step: number; */
  @Prop() dataTab: string;

  render() {
    return (
      <>
        <label-tooltip label={this.label} tooltip={this.tooltip}></label-tooltip>
        <input
          class="form-control-stencil form-control"
          type="number"
          data-tab={this.dataTab}
          name={this.name}
          required={this.required}
          value={this.value}
          placeholder={this.placeholder}
          /* min={this.min}
          max={this.max} */
          disabled={this.disabled}
        />
      </>
    );
  }
}
